import { createContext } from 'react';
import { CalendarMode } from '@/helpers/calendarMode';

export type CalendarModeContextValue = [CalendarMode, (mode: CalendarMode) => void];

const CalendarModeContext = createContext<CalendarModeContextValue | null>(null);

export default CalendarModeContext;
